module.exports = __webpack_public_path__ + "media/images/icons/github-7c32661af4b90e4e1603e1df1fc57935.svg";